import CONSTANTS from "../Constants/Constants";
import { fetchAgentPriceMarkupInfo } from "../services/agentServices";

export const markup = (price, percentage_or_flat_rate_amount=CONSTANTS.prices.markup_percentage, type=CONSTANTS.prices.markup_types.percentage) => {
    let f_price=parseFloat(price);
    let markup=0
    if(type==="price_markup"){ //DB Value
        type=CONSTANTS.prices.markup_types.percentage;
    }else if(type==="flat_rate"){ //DB Value
        type=CONSTANTS.prices.markup_types.flat_rate;
    }
    if(type===CONSTANTS.prices.markup_types.percentage){
        markup = ((parseFloat(percentage_or_flat_rate_amount)/100) * f_price);
    }else if(type===CONSTANTS.prices.markup_types.flat_rate){
        markup = parseFloat(percentage_or_flat_rate_amount);
    }
    let new_price = parseFloat((f_price + markup));
    return {
        type,
        markup_by: percentage_or_flat_rate_amount,
        markup,
        f_price,
        new_price,
    }
}

export const getTotalDefaultFees = (_type="flight_order") => { // _type = [//"package_order", "flight_order"]
    const FEES=CONSTANTS.customer_fees[_type]?.defaults;
    let total=0;
    for(let i=0; i<FEES.length; i++){
        total+=FEES[i].total;
    }
    return total;
}

export const getTotalDefaultFeesNames = (_type="flight_order") => { // _type = [//"package_order", "flight_order"]
    const FEES=CONSTANTS.customer_fees[_type]?.defaults;
    let names="";
    for(let i=0; i<FEES.length; i++){
        names+=(FEES[i].name+", ");
    }
    return names;
}

export const returnTaxRate = (wdg_tax_code="ny-us") => {
    let rate=parseFloat(10/100); // at least 10%
    let city="global";
    if(wdg_tax_code==="ny-us"){
        rate=parseFloat(8.875/100);
        city="New York, USA";
    }
    return {
        city,
        rate
    };
}

(async()=>{
    if(localStorage.getItem("agent")){
        const agent_id = localStorage.getItem("agent");
        if(agent_id || agent_id!=="undefined"){
            window.__priceMarkupInfo = await fetchAgentPriceMarkupInfo(agent_id);
        }
    }
})();

